/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class ForwardAPI extends ApiClient {
  constructor() {
    super('wasapi/conversations', { accountScoped: true });
  }

  forward(conversationId, messageId, targets) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/forward`,
      { targets }
    );
  }
}

export default new ForwardAPI();
